
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import store from "@/store";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
  },
  computed: {},
  methods: {
    onRowPrepared(e: any) {
      if (e.rowType == "header"){
        e.rowElement.bgColor = "#E5F0FF";
      }
    },
    onContentReady(e: any) {
      if (!this.firstRowExpanded) {
        if (e.component.totalCount() > 0) {
          e.component.expandRow(e.component.getKeyByRowIndex(0));
          e.component.selectRowsByIndexes([0]);
          this.firstRowExpanded = true;
        }
      }
    },
  },
  mounted() {
    this.firstRowExpanded = false;
  },
  data() {
    return {
      toolbarItems: [
        {
          location: "before",
          text: "Контейнеры",
        },
      ],
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
          },

          {
            name: "LoadCapacitySummary",
            showInColumn: "loadCapacity",
            column: "loadCapacity",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },

          {
            name: "TotalLoadCapacitySummary",
            showInColumn: "totalLoadCapacity",
            column: "totalLoadCapacity",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },

          {
            name: "PlanCountSummary",
            showInColumn: "planCount",
            column: "planCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
          {
            name: "FactCountSummary",
            showInColumn: "factCount",
            column: "factCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
          {
            name: "ResidueSummary",
            showInColumn: "residue",
            column: "residue",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
          {
            name: "PackagesCountSummary",
            showInColumn: "packagesCount",
            column: "packagesCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
          {
            name: "PackagesWeightSummary",
            showInColumn: "packagesWeight",
            column: "packagesWeight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },
          {
            name: "PackagesBruttoWeightSummary",
            showInColumn: "packagesBruttoWeight",
            column: "packagesBruttoWeight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },
        ],
      },
      firstRowExpanded: false,
      editingConfig: new TableEditingConfig({
        allowDeleteAll: false,
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowImport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
        allowColumnReordering: true,
        enableMasterDetail: true,
        detailComponentName:
          "components/journals/PlanContainerResultJournal/PlanContainerResultDetail.vue",
        mode: "row",
        chooseColumns: true,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "code",
          caption: "Код контейнера",
          readOnly: true,
        }),
        new TextColumnConfig({
          dataField: "sizes",
          caption: "Размеры (мм)",
        }),
        new TextColumnConfig({
          dataField: "displacementDescription",
          caption: "Смещение",
        }),
        new TextColumnConfig({
          dataField: "gapDescription",
          caption: "Отступы (мм)",
        }),

        new DecimalColumnConfig({
          dataField: "requisiteWeight",
          caption: "Вес реквизита (кг)",
          hideFraction: true,
          decimalPoints: 0,
          min: 0,
          step: 1,
        }),

        new DecimalColumnConfig({
          dataField: "emptyWeight",
          caption: "Порожний вес (кг)",
          hideFraction: true,
          decimalPoints: 0,
          min: 0,
          step: 1,
        }),

        new DecimalColumnConfig({
          dataField: "loadStatThreshold",
          caption: "Рек. порог статнагрузки (м³)",
          decimalPoints: 0,
          min: 0,
          step: 1,
        }),

        new DecimalColumnConfig({
          dataField: "loadCapacity",
          caption: "Грузоподъемность (кг)",
          hideFraction: true,
          decimalPoints: 0,
          min: 0,
          step: 1,
        }),
        new DecimalColumnConfig({
          dataField: "totalLoadCapacity",
          caption: "Общая грузоподъемность (т)",
          decimalPoints: 1,
          readOnly: true,
        }),

        new DecimalColumnConfig({
          dataField: "averagePackagesWeight",
          caption: "Средний вес (кг)",
          hideFraction: true,
          decimalPoints: 1,
          readOnly: true,
        }),

        new DecimalColumnConfig({
          dataField: "averagePackagesVolume",
          caption: "Средний объем (м³)",
          decimalPoints: 1,
          readOnly: true,
        }),

        new IntegerColumnConfig({
          dataField: "planCount",
          caption: "План (шт)",
          min: 0,
        }),
        new IntegerColumnConfig({
          dataField: "factCount",
          caption: "Загружено (шт)",
          min: 0,
        }),
        new IntegerColumnConfig({
          dataField: "residue",
          caption: "Остаток (шт)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "packagesCount",
          caption: "Кол-во пакетов (шт)",
          min: 0,
        }),

        new DecimalColumnConfig({
          dataField: "packagesWeight",
          caption: "Вес пакетов нетто (кг)",
          hideFraction: true,
          decimalPoints: 1,
          readOnly: true,
        }),

        new DecimalColumnConfig({
          dataField: "packagesBruttoWeight",
          caption: "Вес пакетов брутто (кг)",
          hideFraction: true,
          decimalPoints: 1,
          readOnly: true,
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: false,
      }),

      selectionConfig: new TableSelectionConfig({
        mode: "single",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
    store.dispatch("loadedPackages/setLoadedPackages", { data: null });
  },
});
